import type { FC, ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports
import { FocusPage as GDSFocusPage } from '@george-labs.com/design-system';
import type { FOCUS_PAGE_SIZE } from '@george-labs.com/design-system/types/components/Page/FocusPage';
import classNames from 'classnames';

import { ErrorBoundaryInCard } from '@shared/error-boundary';

import { FocusPageWrapper } from './FocusPageWrapper';
import type { Props as FocusPageStripeProps } from './FocusPageStripe';
import { FocusPageStripe } from './FocusPageStripe';

export interface FocusPageStatics {
    SIZE: typeof FOCUS_PAGE_SIZE;
}

export interface Props extends FocusPageStripeProps {
    size?: FOCUS_PAGE_SIZE;
    stepper?: ReactNode;
    'data-cy'?: string;
    className?: string;
    showStripe?: boolean;
    children: ReactNode;
    increasePaddings?: boolean;
}

export const FocusPage: FC<Props> & FocusPageStatics = ({
    size = FocusPage.SIZE.MEDIUM,
    stepper,
    'data-cy': dataCy,
    className,
    showStripe = true,
    increasePaddings = true,
    children,
    ...stripeProps
}) => (
    <FocusPageWrapper>
        <GDSFocusPage
            stripeHeader={
                showStripe && (
                    <FocusPageStripe
                        {...stripeProps}
                        stripeClassName={classNames(stripeProps.stripeClassName, 'd-print-none')}
                    />
                )
            }
            size={size}
            stepper={stepper}
            data-cy={dataCy}
            increasePaddings={increasePaddings}
            className={className}
        >
            <ErrorBoundaryInCard>{children}</ErrorBoundaryInCard>
        </GDSFocusPage>
    </FocusPageWrapper>
);

FocusPage.SIZE = GDSFocusPage.SIZE;
